import { Title, Text } from '@mantine/core';
import { SparklesIcon, XIcon } from 'lucide-react';
import {
  SCOUT_IS_UNDER_MAINTENANCE,
  SCOUT_MAINTENANCE_DESCRIPTION,
  SCOUT_MAINTENANCE_TITLE,
} from '../scoutMaintenance';

interface ScoutChatHeaderProps {
  showCloseButton?: boolean;
  onClose?: () => void;
  className?: string;
  style?: React.CSSProperties;
  titleStyle?: React.CSSProperties;
}

export const ScoutChatHeader = ({
  showCloseButton = true,
  onClose,
  className,
  style,
  titleStyle,
}: ScoutChatHeaderProps) => {
  return (
    <div
      style={{
        padding: 'var(--mantine-spacing-md)',
        borderBottom: `1px solid var(--mantine-color-gray-2)`,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        ...style,
      }}
      className={className}
    >
      <div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 'var(--mantine-spacing-xs)',
            ...titleStyle,
          }}
        >
          <SparklesIcon
            size={20}
            color='var(--mantine-color-pink-4)'
            strokeWidth={1.4}
          />
          <Title order={4}>
            {SCOUT_IS_UNDER_MAINTENANCE ? SCOUT_MAINTENANCE_TITLE : 'Ask Scout'}
          </Title>
        </div>
        <Text size='xs' c='dimmed' mt={4}>
          {SCOUT_IS_UNDER_MAINTENANCE
            ? SCOUT_MAINTENANCE_DESCRIPTION
            : 'AI can make mistakes. Not a substitute for professional judgment.'}
        </Text>
      </div>
      {showCloseButton && onClose && (
        <button
          onClick={onClose}
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: '4px',
            display: 'flex',
            alignItems: 'center',
            color: 'var(--mantine-color-dimmed)',
          }}
          aria-label='Close chat'
        >
          <XIcon size={20} />
        </button>
      )}
    </div>
  );
};
